import { render, staticRenderFns } from "./altaciklama.vue?vue&type=template&id=ee92757e&"
import script from "./altaciklama.vue?vue&type=script&lang=js&"
export * from "./altaciklama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports